export default __webpack_public_path__ + "qr-code-border.svg";